import React from "react"
import styled from "styled-components"

import { LinkedIn, Facebook, Twitter, Instagram } from "@material-ui/icons"

import * as theme from "../../theme"

export default props => {
  const { socials } = props

  const getSocialIcon = icon => {
    switch (icon) {
      case "linkedin":
        return <LinkedIn />

      case "facebook":
        return <Facebook />

      case "twitter":
        return <Twitter />

      case "instagram":
        return <Instagram />

      default:
        return null
    }
  }

  if (socials) {
    return (
      <Socials>
        {socials.map(({ url, icon }, index) => (
          <Item key={index} href={url} target="_blank">
            {getSocialIcon(icon)}
          </Item>
        ))}
      </Socials>
    )
  } else {
    return null
  }
}

const Socials = styled.div``

const Item = styled.a`
position: relative;
left: -4px;
  svg {
    width: 30px;
    height: 30px;
    color: white;
    transition: color: 150ms ease-in-out;
  }

  &:hover {
    svg {
      color: ${theme.color.green};
    }
  }
`
